import { isEmailBuilderTextEditableTarget } from "./emailBuilderHistoryHotkeys";

export interface IEmailBuilderSelectionHotkeyEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  target: EventTarget | null;
}

export function resolveEmailBuilderSelectAllHotkey(
  event: IEmailBuilderSelectionHotkeyEvent,
): "select-all" | null {
  if (isEmailBuilderTextEditableTarget(event.target)) {
    return null;
  }

  if (event.shiftKey || event.altKey) {
    return null;
  }

  const modifierPressed = event.metaKey || event.ctrlKey;
  if (!modifierPressed) {
    return null;
  }

  if (event.key.toLowerCase() !== "a") {
    return null;
  }

  return "select-all";
}
